import LikeIcon from "@/icons/like.svg"
import LikeSolidIcon from "@/icons/like-solid.svg"
import CommentIcon from "@/icons/chat.svg"
import CommentSolidIcon from "@/icons/chat-solid.svg"
import ShareSolidIcon from "@/icons/share-rectangle.svg"

export { LikeIcon, LikeSolidIcon, CommentIcon, CommentSolidIcon, ShareSolidIcon };